import React from "react";
import { Navigate } from "react-router-dom";
import { UserCreatePage, USER_TYPES } from "../../modules/user-management";
import useAuth from "../../hooks/useAuth";

const TenantUserCreate = () => {
  const { isSystemUser, activeTenantId } = useAuth();
  if (isSystemUser && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }
  return <UserCreatePage userType={USER_TYPES.TENANT} />;
};

export default TenantUserCreate;
